import React, { Component } from 'react'
import { Dialog } from '@material-ui/core'
import { connect } from 'react-redux'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from 'axios'

import InputField from '@/Common/NewForm/InputField'
import CloseButton from '@/Common/CloseButton'

import i18n from '../../../i18n'
import './index.scss'

class PasswordForgotDialog extends Component {
    state = {}

    initState = () => {
        this.setState({
            email: ""
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open) this.initState()
    }

    handleChangeInput = e => this.setState({ [e.target.name]: e.target.value })
    handleClickOneBtnDialogClose = () => this.setState({ isOneBtnDialogOpen: false })

    handleClickConfirm = async () => {
        const { lang, onClose, handleClickOneBtnDialogOpen } = this.props
        const { email } = this.state

        if (!email || !email.length) return

        try {
            await axios.post(`${GetBaseUrl()}/api/user/pw_forgot`, {
                Email: email,
                lang
            })
            handleClickOneBtnDialogOpen("sendPassword")
            onClose()
        }
        catch (e) {
            if (e.response.status === 403 && e.response.data && e.response.data.message === "Not Found") {
                handleClickOneBtnDialogOpen("notRegisteredEmail")
            }
            else {
                handleClickOneBtnDialogOpen("severError")
            }
        }
    }

    render() {
        const { open, onClose } = this.props
        const {
            email
        } = this.state

        return (
            <Dialog open={open} onClose={onClose}>
                <div className="password-forgot-dialog-root-container">
                    <div className="close-btn" onClick={onClose}>
                        <CloseButton />
                    </div>
                    <div className="title">
                        {i18n.t("login.find.password")}
                    </div>
                    <div className="desc">
                        {i18n.t("login.enter.id.for.password")}
                    </div>
                    <div className="form-container">
                        <div className="input-wrapper">
                            <InputField
                                type="text"
                                name="email"
                                value={email}
                                placeholder={i18n.t("login.enter.email")}
                                onChange={this.handleChangeInput}
                                maxLength={100}
                            />
                        </div>
                    </div>
                    <div className="password-forgot-button" onClick={this.handleClickConfirm}>
                        {i18n.t("global.confirm")}
                    </div>
                </div>
            </Dialog>
        )
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(PasswordForgotDialog)